import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import "../form-input/form-input.component.css";
import { ReactComponent as VisibilityIcon } from "../../../assets/visibility-icon.svg";
import { ReactComponent as VisibilityOffIcon } from "../../../assets/visibility-off-icon.svg";
import { ReactComponent as RemoveIcon } from "../../../assets/cross.svg";
import Loader from "../loader/loader.component";
import { useChangeEmailPassword } from "./useChangeEmailPassword";
import { useStyles } from "./change-email-password.styles";
import {
  ChangeEmailPasswordFormValues,
  ChangeEmailPasswordProps,
} from "./change-email-password.types";

const DEFAULT_BORDER = "1px solid rgba(0, 0, 0, 0.08)";

const ChangeEmailPassword: React.FC<ChangeEmailPasswordProps> = ({
  isEmailType,
  handleCloseModal,
  onSubmit,
  updatePassLoader,
  changeEmailAddressLoader,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { visiblePasswordFields, togglePasswordVisibility } =
    useChangeEmailPassword();

  const {
    register,
    handleSubmit,
    watch,
    formState: { isValid },
  } = useForm<ChangeEmailPasswordFormValues>({ mode: "onChange" });

  const title = isEmailType
    ? t("common.changeOfEmail")
    : t("common.changeOfPassword");

  return (
    <form className={classes.container} onSubmit={handleSubmit(onSubmit)}>
      <div
        className={classes.header}
        style={{ direction: t("css.side") as "ltr" | "rtl" }}
      >
        <span className={classes.title}>{title}</span>
        <span className="pointer" onClick={handleCloseModal}>
          <RemoveIcon style={{ height: 24, width: 24 }} />
        </span>
      </div>

      {isEmailType ? (
        <div>
          <div className="group" style={{ margin: "0 0 48px 0px" }}>
            <input
              id="email"
              type="text"
              className="form-input h6-regular"
              style={{ color: "#000000", borderBottom: "1px solid rgba(0, 0, 0, 0.1)" }}
              {...register("email", { required: true })}
            />
            <label
              htmlFor="email"
              className={`h6-regular form-input-label ${
                watch("email") ? "shrink" : ""
              }`}
            >
              {t("auth.Email")}
            </label>
          </div>
          <div className={classes.fieldWrapper}>
            <div className="group" style={{ margin: "0 0 24px 0px" }}>
              <input
                id="password"
                type={visiblePasswordFields.password ? "text" : "password"}
                className="form-input h6-regular"
                style={{ color: "#000000", borderBottom: DEFAULT_BORDER }}
                {...register("password", { required: true })}
              />
              <label
                htmlFor="password"
                className={`h6-regular form-input-label ${
                  watch("password") ? "shrink" : ""
                }`}
              >
                {t("auth.Password")}
              </label>
              <span className="h7-regular" style={{ opacity: 0.4 }}>
                {t("common.toConfirmEmailChange")}
              </span>
            </div>
            <span
              className={classes.toggleVisibility}
              onClick={() => togglePasswordVisibility("password")}
            >
              {visiblePasswordFields.password ? (
                <VisibilityIcon />
              ) : (
                <VisibilityOffIcon />
              )}
            </span>
          </div>
        </div>
      ) : (
        <div>
          <div className={classes.fieldWrapper}>
            <div className="group" style={{ margin: "0 0 48px 0" }}>
              <input
                id="oldPassword"
                type={visiblePasswordFields.oldPassword ? "text" : "password"}
                className="form-input h6-regular"
                style={{ color: "#000000", borderBottom: DEFAULT_BORDER }}
                {...register("oldPassword", { required: true })}
              />
              <label
                htmlFor="oldPassword"
                className={`h6-regular form-input-label ${
                  watch("oldPassword") ? "shrink" : ""
                }`}
              >
                {t("auth.oldPassword")}
              </label>
            </div>
            <span
              className={classes.toggleVisibility}
              onClick={() => togglePasswordVisibility("oldPassword")}
            >
              {visiblePasswordFields.oldPassword ? (
                <VisibilityIcon />
              ) : (
                <VisibilityOffIcon />
              )}
            </span>
          </div>
          <div className={classes.fieldWrapperTall}>
            <div className="group" style={{ margin: "0 0 24px 0px" }}>
              <input
                id="newPassword"
                type={visiblePasswordFields.newPassword ? "text" : "password"}
                className="form-input h6-regular"
                style={{ color: "#000000", borderBottom: DEFAULT_BORDER }}
                {...register("newPassword", { required: true })}
              />
              <label
                htmlFor="newPassword"
                className={`h6-regular form-input-label ${
                  watch("newPassword") ? "shrink" : ""
                }`}
              >
                {t("auth.newPassword")}
              </label>
            </div>
            <span
              className={classes.toggleVisibility}
              onClick={() => togglePasswordVisibility("newPassword")}
            >
              {visiblePasswordFields.newPassword ? (
                <VisibilityIcon />
              ) : (
                <VisibilityOffIcon />
              )}
            </span>
          </div>
        </div>
      )}

      <div className={classes.submitButtonWrapper}>
        <button
          type="submit"
          className={classes.submitButton}
          disabled={!isValid}
        >
          {updatePassLoader || changeEmailAddressLoader ? (
            <Loader color="#B73232" size={20} />
          ) : (
            t("common.Save")
          )}
        </button>
      </div>
    </form>
  );
};

export default ChangeEmailPassword;
